import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767c2d1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center gap-[30px]" }
const _hoisted_2 = { class: "flex gap-[4px] flex-nowrap items-center justify-center whitespace-nowrap" }
const _hoisted_3 = { class: "text-Text/text_high font-gordita-medium" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "uil icon-right-small text-Text/text_medium",
  style: {"font-size":"10px","margin":"0 6px"}
}, null, -1))
const _hoisted_6 = { class: "flex gap-[16px] p-[16px] border-b border-b-System/app_border" }
const _hoisted_7 = { class: "flex justify-between items-center h-[48px] mx-[16px]" }
const _hoisted_8 = { class: "font-gordita-regular text-[13px] text-Text/text_medium" }

import { IncrediButton, IncrediMenu, IncrediList, IncrediItem, IncrediCard } from 'incredi-ui';
import DatePickerInput from '@/components/date-picker/components/date-picker-input.vue';
import { computed, ref, watch, withDefaults } from 'vue';
import { onClickOutside } from '@vueuse/core';
import moment from 'moment';
import { useI18n } from 'vue-i18n';
import { isTargetPartOf } from '@/services/utils';
import IbxScopedCss from '../IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'date-picker',
  props: {
    modelValue: null,
    dateFromLimitationFn: { type: Function, default: undefined },
    dateToLimitationFn: { type: Function, default: undefined },
    navigationMinYearMonth: { default: undefined },
    navigationMaxYearMonth: { default: undefined },
    maxDays: { default: undefined },
    daysPresets: { default: () => [6, 13, 29] },
    disabled: { type: Boolean },
    buttonLabelCustomTimeFrame: null,
    hideDaysLabel: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: { from: moment.Moment; to: moment.Moment }): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: {
      from: moment.Moment | null;
      to: moment.Moment | null;
    }, dateFromLimitationFn: (date: string, _localDate: typeof localDate['value']) => boolean, dateToLimitationFn: (date: string, _localDate: typeof localDate['value']) => boolean, navigationMinYearMonth: string, navigationMaxYearMonth: string, maxDays: number, daysPresets: number[], disabled?: boolean, buttonLabelCustomTimeFrame?: string, hideDaysLabel?: boolean }

const { t } = useI18n();
const menuRef = ref(null);
const datePickerInputRef = ref(null);
const menuOpen = ref(false);
const datePickerMenuOpen = ref(false);
const localDate = ref({ from: moment().format('YYYY/MM/DD'), to: moment().format('YYYY/MM/DD') });




const handleMenuButtonClick = (e: MouseEvent) => {
  if (menuOpen.value) {
    e.stopPropagation();
    menuOpen.value = false;
  }
};

const closeMenu = () => {
  menuOpen.value = false;
  datePickerMenuOpen.value = false;
};

const setDisplayDays = (days: number) => {
  if (days === 0) {
    return t('datePicker.today');
  }
  return `${t('datePicker.last')} ${days + 1} ${t('datePicker.days')}`;
};

const changeDates = () => {
  emit('update:modelValue', {
    from: moment(localDate.value.from, 'YYYY/MM/DD').startOf('day'),
    to: moment(localDate.value.to, 'YYYY/MM/DD').endOf('day'),
  });
  closeMenu();
};

const daysDifference = computed(() => {
  if (!props.modelValue.from || !props.modelValue.to) return 0;
  const startDate = moment(props.modelValue.from, 'YYYY/MM/DD');
  const endDate = moment(props.modelValue.to, 'YYYY/MM/DD');
  return endDate.diff(startDate, 'days');
});
const daysDifferenceLocal = computed(() => {
  const startDate = moment(localDate.value.from, 'YYYY/MM/DD');
  const endDate = moment(localDate.value.to, 'YYYY/MM/DD');
  return endDate.diff(startDate, 'days');
});

const changeLocalFromDate = (value: string) => {
  localDate.value.from = value;
  (datePickerInputRef.value as any)?.openMenu();
  if (props.maxDays && (daysDifferenceLocal.value || 0) > props.maxDays) localDate.value.to = moment(value, 'YYYY/MM/DD').add(props.maxDays, 'days').format('YYYY/MM/DD');
  if (daysDifferenceLocal.value < 0) {
    localDate.value.to = value;
  }
};

const dateFromLimitationFn = (date: string) => {
  const today = moment().format('YYYY/MM/DD');
  const localValidation = date <= today;
  if (props.dateFromLimitationFn) {
    return localValidation && props.dateFromLimitationFn(date, localDate.value);
  }
  return localValidation;
};

const dateToLimitationFn = (date: string) => {
  const localValidation = date >= localDate.value.from;
  if (props.dateToLimitationFn) {
    return localValidation && props.dateToLimitationFn(date, localDate.value);
  }
  return localValidation;
};

const setPresetDays = (days: number) => {
  emit('update:modelValue', {
    from: moment().subtract(days, 'days').startOf('day'),
    to: moment().endOf('day'),
  });
  closeMenu();
};

const presetsSelected = computed(() =>
  props.daysPresets.reduce((acc, curr) => {
    acc[curr] = moment().subtract(curr, 'days').format('YYYY/MM/DD') === props.modelValue.from?.format('YYYY/MM/DD') && props.modelValue.to?.format('YYYY/MM/DD') === moment().format('YYYY/MM/DD');
    return acc;
  }, {} as Record<typeof props.daysPresets[number], boolean>),
);

const buttonLabel = computed(() => {
  if (Object.values(presetsSelected.value).some(value => value) && !props.buttonLabelCustomTimeFrame) {
    if (daysDifference.value === 0) {
      return t('datePicker.today');
    }
    return `${t('datePicker.last')} ${daysDifference.value + 1} ${t('datePicker.days')}`;
  }
  if (!props.modelValue.from || !props.modelValue.to) return '';

  const { from, to } = props.modelValue;
  const sameYear = from.year() === to.year();
  const sameMonth = sameYear && from.month() === to.month();
  const sameDay = sameMonth && from.date() === to.date();
  const hasCustom = !!props.buttonLabelCustomTimeFrame;
  const fromFormat = `D${sameMonth ? '' : ' MMM'}${sameYear ? '' : ' YYYY'}`;
  return [
    // custom times
    props.buttonLabelCustomTimeFrame,
    // pipe separator
    hasCustom && '|',
    // from
    sameDay ? '' : `${from.format(fromFormat)} - `,
    // to
    `${to.format('D MMM YYYY')}`,
  ]
    .filter(Boolean)
    .join(' ');
});

onClickOutside(menuRef, event => {
  // Using the 'as Event' to tell TypeScript we're sure it's an Event object
  const target = (event as Event).target as Node;
  // Check if the click target is a part of the q-date picker
  // If the click originated from the date picker, don't close the menu
  if (isTargetPartOf(target, ['date-picker--q-date', 'trigger-button'])) return;

  closeMenu();
});
const daysLabel = computed(() => {
  if (props.hideDaysLabel) return '';
  return `${localDate.value.from && localDate.value.from === localDate.value.to ? '1' : daysDifferenceLocal.value + 1} ${t('datePicker.days')}`;
});
watch(
  () => props.modelValue,
  newValue => {
    if (!newValue.from || !newValue.to) return;
    localDate.value = {
      from: newValue.from.format('YYYY/MM/DD'),
      to: newValue.to.format('YYYY/MM/DD'),
    };
  },
  {
    immediate: true,
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IncrediMenu), {
          direction: "bottom-sticky-left",
          "offset-y": 4,
          "offset-x": 0,
          "model-value": __props.disabled ? false : menuOpen.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = (e) => menuOpen.value = e)
        }, {
          content: _withCtx(() => [
            _createVNode(IbxScopedCss, {
              ref_key: "menuRef",
              ref: menuRef,
              style: {"width":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IncrediList), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.daysPresets, (days, index) => {
                      return (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: index,
                        "data-testid": `date-picker-preset-${days}`,
                        selected: _unref(presetsSelected)[days],
                        onClick: ($event: any) => (setPresetDays(days))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(setDisplayDays(days)), 1)
                        ]),
                        _: 2
                      }, 1032, ["data-testid", "selected", "onClick"]))
                    }), 128)),
                    _createVNode(_unref(IncrediItem), {
                      selected: 
                  !!(
                    __props.modelValue.to &&
                    __props.modelValue.from &&
                    !!__props.daysPresets.every(
                      days => _unref(moment)().subtract(days, 'days').format('YYYY/MM/DD') !== __props.modelValue.from?.format('YYYY/MM/DD') && __props.modelValue.to?.format('YYYY/MM/DD') !== _unref(moment)().format('YYYY/MM/DD'),
                    )
                  )
                ,
                      active: datePickerMenuOpen.value,
                      onMouseover: _cache[2] || (_cache[2] = ($event: any) => (datePickerMenuOpen.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IncrediMenu), {
                          modelValue: datePickerMenuOpen.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datePickerMenuOpen).value = $event)),
                          direction: "bottom-right",
                          "offset-y": -25,
                          "offset-x": 15
                        }, {
                          content: _withCtx(() => [
                            _createVNode(IbxScopedCss, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IncrediCard), { class: "date-picker--q-date !rounded-[2px]" }, {
                                  default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "date-picker-prepend"),
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(DatePickerInput, {
                                        "model-value": localDate.value.from,
                                        label: _ctx.$t('datePicker.from'),
                                        "q-date-options": dateFromLimitationFn,
                                        "navigation-max-year-month": __props.navigationMaxYearMonth || __props.maxDays ? _unref(moment)(localDate.value.from).add(__props.maxDays, 'days').format('YYYY/MM') : undefined,
                                        "navigation-min-year-month": __props.navigationMinYearMonth,
                                        "onUpdate:modelValue": changeLocalFromDate
                                      }, null, 8, ["model-value", "label", "navigation-max-year-month", "navigation-min-year-month"]),
                                      _createVNode(DatePickerInput, {
                                        ref_key: "datePickerInputRef",
                                        ref: datePickerInputRef,
                                        modelValue: localDate.value.to,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localDate.value.to) = $event)),
                                        "navigation-max-year-month": __props.navigationMaxYearMonth || __props.maxDays ? _unref(moment)(localDate.value.from).add(__props.maxDays, 'days').format('YYYY/MM') : undefined,
                                        "navigation-min-year-month": __props.navigationMinYearMonth,
                                        label: _ctx.$t('datePicker.to'),
                                        "q-date-options": dateToLimitationFn
                                      }, null, 8, ["modelValue", "navigation-max-year-month", "navigation-min-year-month", "label"])
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(daysLabel)), 1),
                                      _createVNode(_unref(IncrediButton), {
                                        size: "small",
                                        onClick: changeDates
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('datePicker.apply')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 3
                                })
                              ]),
                              _: 3
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('datePicker.custom')), 1),
                              _hoisted_5
                            ])
                          ]),
                          _: 3
                        }, 8, ["modelValue"])
                      ]),
                      _: 3
                    }, 8, ["selected", "active"])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 512)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_unref(IncrediButton), {
                "data-testid": "date-picker-trigger-button",
                class: "trigger-button",
                design: "ghost-neon",
                size: "tiny",
                disabled: __props.disabled,
                selected: 
              menuOpen.value ||
              !!(
                __props.modelValue.to &&
                __props.modelValue.from &&
                !!__props.daysPresets.every(
                  days => _unref(moment)().subtract(days, 'days').format('YYYY/MM/DD') !== __props.modelValue.from?.format('YYYY/MM/DD') && __props.modelValue.to?.format('YYYY/MM/DD') !== _unref(moment)().format('YYYY/MM/DD'),
                )
              )
            ,
                "override-style": {
              height: '32px',
              padding: '10px 8px',
            },
                onClick: handleMenuButtonClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('datePicker.date')) + _toDisplayString(__props.modelValue.from && __props.modelValue.to ? ':' : ''), 1),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(buttonLabel)), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["uil uil-angle-down text-Text/text_medium leading-[20px]", {
                  '!text-text/text_disabled': __props.disabled,
                }]),
                      style: {"font-size":"20px","margin":"0 4px 0px 2px"}
                    }, null, 2)
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "selected"])
            ])
          ]),
          _: 3
        }, 8, ["model-value"])
      ])
    ]),
    _: 3
  }))
}
}

})